'use client';
import { UAEntityTypes } from '@unifyapps/defs/types/entities';
import type { InterfaceEntity } from '@unifyapps/defs/types/interface';
import { useFindDeployedEntityById } from '@unifyapps/network/generated/entity-rest-api/entity-rest-api';
import { InterfaceClient } from '../../../../../stores/InterfaceStore';
import type { UseFetchResourcesHookType } from '../../../types';
import { useGetAuthDeployedInterface } from '../useAuthDeployedInterface';
import { useAuthPageResourcesFromRecord } from './useAuthPageResourcesFromRecord';

// Authorization strategy (governance pages): resolves the interface record by domain/host, falling
// back to the authenticated entity-by-id route. Platform auth pages use the PlatformAuthorization
// strategy (`useFetchPlatformAuthDeployedInterfaceResources`) instead of branching here on a flag.
const useFetchAuthDeployedInterfaceResources: UseFetchResourcesHookType = ({
  interfaceId,
  interfaceComponent,
  client,
  disableAuth = false,
  mode,
}) => {
  const authEntityInterface = useGetAuthDeployedInterface<InterfaceEntity>({
    query: {
      enabled: client === InterfaceClient.UA_MATRIX && !disableAuth,
      staleTime: Infinity,
    },
  });

  const {
    data,
    isLoading,
    error: findEntityError,
  } = useFindDeployedEntityById<InterfaceEntity>(UAEntityTypes.Interface, interfaceId, {
    query: {
      enabled: (Boolean(interfaceId) && client === InterfaceClient.UA_PLATFORM) || disableAuth,
    },
  });

  return useAuthPageResourcesFromRecord({
    interfaceRecord: authEntityInterface.data || data,
    isLoadingInterfaceRecord: authEntityInterface.isLoading || isLoading,
    errorInterfaceRecord: authEntityInterface.error || findEntityError,
    interfaceComponent,
    mode,
  });
};

export default useFetchAuthDeployedInterfaceResources;
